export default "/iframe-quick-instructions.07e90732-473cdc.png";